import React, { Component } from 'react'
import mapboxgl from 'mapbox-gl'
// eslint-disable-next-line import/no-webpack-loader-syntax
import MapboxWorker from 'worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker'
import ReactMapboxGl, { ZoomControl, Marker, GeoJSONLayer } from 'react-mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css'
import { MAPBOX_API_KEY } from '../../../constants'
import { Columns } from 'components/elements/index.js'
import ListingMapMarker from './ListingMapMarker'
import * as turf from '@turf/turf'
import geojsonStyles from './geojsonStyles'
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
import MapBoxErrorBoundary from './MapBoxErrorBoundary'
import ThrowError from './ThrowError'

mapboxgl.workerClass = MapboxWorker

const Map = ReactMapboxGl({
  accessToken: MAPBOX_API_KEY
});

class ProfileMap extends Component {
  constructor(props) {
    super(props)
    this.state = {
      options: this.props.isMobile
        ? this.createMobileMapOptions
        : this.createDesktopMapOptions,
      hasMapError: false,
    }
  }

  createDesktopMapOptions = (maps) => {
    return {
      zoomControl: true,
      zoomControlOptions: {
        position: maps.ControlPosition.LEFT_TOP,
        style: maps.ZoomControlStyle.SMALL,
      },
      scrollwheel: false,
      fullscreenControl: false,
      gestureHandling: 'cooperative',
    }
  }

  createMobileMapOptions = (maps) => {
    return {
      zoomControl: true,
      zoomControlOptions: {
        position: maps.ControlPosition.LEFT_TOP,
        style: maps.ZoomControlStyle.SMALL,
      },
      // scrollwheel: false,
      fullscreenControl: false,
      gestureHandling: 'greedy',
    }
  }

  render() {
    const {
      latitude,
      longitude,
      searchResults,
      offset,
      location: searchLocation,
      isMobile,
      city
    } = this.props

    const centerPoint = [longitude, latitude];

    var radius = 0.1;

    var options = {
      steps: 50,
      units: "miles",
      properties: {
        text: city
      }
    };

    const firstCircle = turf.circle(centerPoint, radius, options);

    return (
      <React.Fragment>
        {latitude && (
          <MapBoxErrorBoundary>
            <ThrowError shouldThrowError={this.state.hasMapError} />
            <Columns>
              <Columns.Column>
                <div
                  className="bike-profile-map-outer events-search-map-container"
                  id="search-right-map"
                >
                  <Map
                    style="mapbox://styles/mapbox/streets-v9"
                    containerStyle={{
                      height: '100%',
                      width: '100%'
                    }}
                    center={[Number(longitude), Number(latitude)]}
                    zoom={[15]}
                    onStyleLoad={(map) => {
                      map.on('error', (e) => {
                        this.setState({ hasMapError: true });
                      });
                    }}
                  >
                    <ZoomControl
                      position="top-left"
                    />
                    <GeoJSONLayer {...geojsonStyles} data={firstCircle} />
                    {searchResults?.map((result, index) => (
                      <Marker
                        key={index}
                        style={{
                          width: 30,
                          height: 30
                        }}
                        coordinates={[Number(result[0].bike_location.longitude), Number(result[0].bike_location.latitude)]}
                        anchor="bottom"
                      >
                        <ListingMapMarker
                          key={index}
                          isMobile={isMobile}
                          lat={Number(result.location.search_latitude)}
                          lng={Number(result.location.search_longitude)}
                          location={searchLocation}
                          event={result}
                        />
                        {/* <img src={"http://simpleicon.com/wp-content/uploads/map-marker-1.png"} /> */}
                      </Marker>
                    ))}
                  </Map>
                </div>
              </Columns.Column>
            </Columns>
          </MapBoxErrorBoundary>
        )}
      </React.Fragment>
    )
  }
}

export default ProfileMap
